import React, { useState, useEffect } from 'react';

const VoicePreviewApp = () => {
    const [voices, setVoices] = useState<any[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [selectedLanguage, setSelectedLanguage] = useState('English');
    const [selectedGender, setSelectedGender] = useState('Female');

    useEffect(() => {
        const fetchVoices = async () => {
            const options = {
                method: 'GET',
                headers: {
                    accept: 'application/json',
                    'x-api-key': 'Y2FjMzM3MjhlOGRkNGI5YWJkZWIzNjNjOGM1ZTc1NjAtMTcyMjQ4MzQwNw=='
                }
            };

            try {
                const response = await fetch('https://api.heygen.com/v2/voices', options);
                const data = await response.json();
                if (data.error) {
                    throw new Error(data.error);
                }
                setVoices(data.data.voices);
            } catch (err) {
                if (err instanceof Error) {
                    setError(err.message);
                } else {
                    setError('An unknown error occurred');
                }
            } finally {
                setLoading(false);
            }
        }
        fetchVoices();
        
    }, []);

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedLanguage(event.target.value);
  };

  const handleGenderChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedGender(event.target.value);
  };

  const filteredVoices = voices.filter(voice => 
    (selectedLanguage === 'All' || voice.language === selectedLanguage) &&
    (selectedGender === 'All' || voice.gender === selectedGender)
  );

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (error) {
      return (
        <div>
            <h1>Error</h1>
            <p>{error}</p>
        </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Voice Preview App</h1>
      <div className="mb-4">
        <label htmlFor="language" className="mr-2">Filter by Language:</label>
        <select id="language" value={selectedLanguage} onChange={handleLanguageChange} className="p-2 border rounded">
          <option value="All">All</option>
          {Array.from(new Set(voices.map(voice => voice.language))).map(language => (
            <option key={language} value={language}>{language}</option>
          ))}
        </select>
      </div>
      <div className="mb-4">
        <label htmlFor="gender" className="mr-2">Filter by Gender:</label>
        <select id="gender" value={selectedGender} onChange={handleGenderChange} className="p-2 border rounded">
          <option value="All">All</option>
          {Array.from(new Set(voices.map(voice => voice.gender))).map(gender => (
            <option key={gender} value={gender}>{gender}</option>
          ))}
        </select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredVoices.map((voice) => (
          <div key={voice.voice_id} className="border p-4 rounded-lg">
                <h2 className="text-lg font-semibold">{voice.name}</h2>
            <p>Language: {voice.language}</p>
                <p>Gender: {voice.gender}</p>
                <p className="text-xs">ID: {voice.voice_id}</p>
            <audio controls className="mt-2 w-full">
              <source src={voice.preview_audio} type="audio/wav" />
              Your browser does not support the audio element.
            </audio>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VoicePreviewApp;